import Footer from 'components/common/Footer/Footer'
import React from 'react'
import { useStyles } from './styles'

interface StaticPageWrapperProps {
    title: string
}

export const StaticPageWrapper: React.FC<StaticPageWrapperProps> = ({ children, title }) => {
    const classes = useStyles()

    return (
        <div className={classes.container}>
            <div className={classes.content}>
                <article className={classes.article}>
                    <h1 className={classes.title}>{title}</h1>
                    {children}
                </article>
            </div>
            <Footer />
        </div>
    )
}

export default React.memo(StaticPageWrapper)
